import React from "react";
import { Card } from "antd";

const CustomCard = ({ children }) => {
  return (
    <Card className="custom-card">
      {children} {/* Render passed children */}
    </Card>
  );
};

export default CustomCard;
